import { render, staticRenderFns } from "./HotService.vue?vue&type=template&id=54e5869a&scoped=true&"
import script from "./HotService.vue?vue&type=script&lang=js&"
export * from "./HotService.vue?vue&type=script&lang=js&"
import style0 from "./HotService.vue?vue&type=style&index=0&id=54e5869a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5869a",
  null
  
)

export default component.exports